import CharacterSettingsModal from "./CharacterSettingsModal";

export default CharacterSettingsModal;
export { CharacterSettingsModal };
